import React from 'react';
import { Modal } from '../../../../../../CommonComponents/OPL/Modal/Modal';
import { ModalBody } from '../../../../../../CommonComponents/OPL/Modal/ModalBody';
import { ModalCloseButton } from '../../../../../../CommonComponents/OPL/Modal/ModalCloseButton';
import { ModalHeader } from '../../../../../../CommonComponents/OPL/Modal/ModalHeader';
import { ModalFooter } from '../../../../../../CommonComponents/OPL/Modal/ModalFooter';
import { Box } from '../../../../../../CommonComponents/OPL/Box/Box';
import { Button } from '../../../../../../CommonComponents/OPL/Button/Button';
import { useRemoveAccount } from '../../../../api/useRemoveAccount';
import { Alert } from '../../../../../../CommonComponents/OPL/Alert/Alert';

interface Props {
  clientId: string | number;
  accountId: string;
  accountName: string;
  onSuccess: () => void;
  closeModal: () => void;
}

export const DeleteModal: React.FC<Props> = ({
  accountId,
  accountName,
  clientId,
  closeModal,
  onSuccess,
}) => {
  const { mutateAsync: removeAccount, isLoading, error } = useRemoveAccount();

  return (
    <Modal isOpen size="medium" onRequestClose={closeModal}>
      <ModalHeader variant="warning">Warning</ModalHeader>

      <ModalCloseButton disabled={isLoading} onClick={closeModal} />

      {error && <Alert message={error.toString()} variant="error" mx="24" mt="0" mb="16" />}

      <ModalBody>
        Are you sure you want to remove your <strong>{accountName}</strong> account?
      </ModalBody>

      <ModalFooter>
        <Box display="flex" justifyContent="flex-end">
          <Button disabled={isLoading} variant="subtleInactive" onClick={closeModal}>
            Cancel
          </Button>

          <Button
            disabled={isLoading}
            isLoading={isLoading}
            variant="error"
            ml="12"
            onClick={async () => {
              await removeAccount({ clientId, accountId });
              await onSuccess();
              closeModal();
            }}
          >
            Remove Account
          </Button>
        </Box>
      </ModalFooter>
    </Modal>
  );
};
